import {createTheme} from "@mui/material";
import '@fontsource-variable/montserrat';
import '@fontsource/poppins';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/noto-mono';

export const FONTS = {
  MONTSERRAT: 'Montserrat Variable, sans-serif',
  NOTO_MONO: 'Noto Mono'
}

const COMPONENTS = {
  WHITE: '#FFFFFF',
  BLUE: '#0173C6',
  LIGHT_BLUE: '#81B3D8',
  LIGHT_GRAY: '#A8ADB7',
  CERAMIC: '#EFEFEF',
  RED: '#D12E26',
  YELLOW: '#E0C656',
  GREEN: '#4D9640',
}

const TEXT = {
  WHITE: '#FFFFFF',
  BLACK: '#384855',
  BLUE: '#3075BA',
  RED: '#D12E26',
}

const theme = createTheme({
  typography: {
    fontFamily: [
      FONTS.MONTSERRAT,
      FONTS.NOTO_MONO,
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      'Poppins',
    ].join(','),
    allVariants: {
      //fontVariantNumeric: 'tabular-nums',
    },
  },
  palette: {
    primary: {
      main: COMPONENTS.BLUE,
      contrastText: TEXT.WHITE,
    },
    light_blue: {
      main: COMPONENTS.LIGHT_BLUE,
      contrastText: TEXT.WHITE,
    },
    white: {
      main: COMPONENTS.WHITE,
      contrastText: TEXT.BLACK,
    },
    green: {
      main: COMPONENTS.GREEN,
      contrastText: TEXT.BLACK,
    },
    lightGray: {
      main: COMPONENTS.LIGHT_GRAY,
      contrastText: TEXT.BLACK,
    },
    ceramic: {
      main: COMPONENTS.CERAMIC,
      contrastText: TEXT.BLACK,
    },
    text: {
      primary: TEXT.WHITE,
      secondary: TEXT.BLUE,
    },
    error: {
      main: TEXT.RED,
    },
    blood: {
      main: COMPONENTS.RED,
    },
    plasma: {
      main: COMPONENTS.YELLOW,
    },
  },
});

export default theme;
